import {createSlice} from '@reduxjs/toolkit';

import type {EntitlementGrant, EntitlementPreset, EntitlementRole, OpenRequest} from './typedef';
import type {PayloadAction} from '@reduxjs/toolkit';
import type {EntitlementResource} from 'src/openapi/admin/models/EntitlementResource';
import type {AppState} from 'src/store/typedef';
import type {ServerResponse} from 'src/typedef';


type DrawerDetails = {
    shown: boolean,
    history: OpenRequest[],

    resourceDetails: ServerResponse<EntitlementResource> | null,
    grantDetails: ServerResponse<EntitlementGrant> | null,
    roleDetails: ServerResponse<EntitlementRole> | null,
    presetDetails: ServerResponse<EntitlementPreset> | null,
};

export const initialState: DrawerDetails = {
    shown: false,
    history: [],

    resourceDetails: null,
    grantDetails: null,
    roleDetails: null,
    presetDetails: null,
};

export const entitlementDrawerSlice = createSlice({
    name: 'entitlementDrawer',
    initialState,
    reducers: {
        openDrawer: (state, action: PayloadAction<OpenRequest>) => {
            state.shown = true;
            state.history = [action.payload];

            state.resourceDetails = null;
            state.grantDetails = null;
            state.roleDetails = null;
            state.presetDetails = null;
        },
        replace: (state, action: PayloadAction<OpenRequest>) => {
            state.history = [...state.history.slice(0, -1), action.payload];
        },
        back: state => {
            if (history.length > 1) {
                state.history = state.history.slice(0, -1);

                state.resourceDetails = null;
                state.grantDetails = null;
                state.roleDetails = null;
                state.presetDetails = null;
            }
        },
        next: (state, action: PayloadAction<OpenRequest>) => {
            state.history = [...state.history, action.payload];

            state.resourceDetails = null;
            state.grantDetails = null;
            state.roleDetails = null;
            state.presetDetails = null;
        },
        closeDrawer: state => {
            state.shown = false;
            state.history = [];

            state.resourceDetails = null;
            state.grantDetails = null;
            state.roleDetails = null;
            state.presetDetails = null;
        },


        setResourceDetails: (state, action: PayloadAction<ServerResponse<EntitlementResource>>) => {
            state.resourceDetails = action.payload;
        },
        setGrantDetails: (state, action: PayloadAction<ServerResponse<EntitlementGrant>>) => {
            state.grantDetails = action.payload;
        },
        setRoleDetails: (state, action: PayloadAction<ServerResponse<EntitlementRole>>) => {
            state.roleDetails = action.payload;
        },
        setPresetDetails: (state, action: PayloadAction<ServerResponse<EntitlementPreset>>) => {
            state.presetDetails = action.payload;
        },
    },
});

export const {
    openDrawer,
    closeDrawer,
    back,
    next,
    replace,

    setResourceDetails,
    setGrantDetails,
    setRoleDetails,
    setPresetDetails,
} = entitlementDrawerSlice.actions;

export const selectDrawerDetails = (state: AppState) => state.entitlementDrawer;
